import { exibirNomeProduto } from './nomenclatura';
import { isFictor } from './perfilFictor';

interface TipoProduto {
  value: string;
  label: string;
}

let TiposProduto: TipoProduto[] = [
  { value: 'CARTAO_BENEFICIO', label: 'Cartão Benefício' },
  { value: 'ANTECIPACAO_REMUNERACAO', label: 'Antecipação de Remuneração' },
  { value: 'CARTAO_CREDITO', label: 'Cartão Crédito' },
  { value: 'EMPRESTIMO', label: 'Empréstimo' },
];

const { REACT_APP_PERFIL } = process.env;

TiposProduto = REACT_APP_PERFIL === 'QISTA'
  ? TiposProduto.filter(p => p.value !== 'ANTECIPACAO_REMUNERACAO')
  : TiposProduto;

if (isFictor) {
  TiposProduto = [
    { value: 'RCC_SAQUE', label: 'RCC - Cartão Benefício - SAQUE' },
    { value: 'RCC_COMPRA', label: 'RCC - Cartão Benefício - COMPRA' },
    { value: 'CARTAO_CREDITO', label: 'RMC - Cartão Consignado' },
    { value: 'EMPRESTIMO', label: 'Empréstimo' },
  ];
}

const getLabelTipoProduto = (value: string | undefined): string => {
  if (!value) return '-';
  const tipoProduto = TiposProduto.find(prod => prod.value === value);
  return tipoProduto?.label || exibirNomeProduto(value);
};

export const EnumTipoProduto = {
  RCC_SAQUE: 'RCC_SAQUE',
  RCC_COMPRA: 'RCC_COMPRA',
  CARTAO_BENEFICIO_COMPRA: 'CARTAO_BENEFICIO_COMPRA',
  CARTAO_BENEFICIO: 'CARTAO_BENEFICIO',
  ANTECIPACAO_REMUNERACAO: 'ANTECIPACAO_REMUNERACAO',
  CARTAO_CREDITO: 'CARTAO_CREDITO',
  EMPRESTIMO: 'EMPRESTIMO',
} as const;

export type TipoProdutoValues = keyof typeof EnumTipoProduto; // opcional, só se quiser usar tipo

export { TiposProduto, getLabelTipoProduto };

export const isProdutoEmprestimo = (tipo?: string) =>
  tipo === 'EMPRESTIMO' || tipo === 'ANTECIPACAO_REMUNERACAO' ||
  (isFictor && (tipo === 'RCC_SAQUE' || tipo === 'RCC_COMPRA'));

// A conversão só é gravada quando o usuário salva o cadastro com a política de empréstimo.
export const tipoProdutoParaCadastro = (tipo: string) => {
  if (!isFictor) return tipo;
  if (tipo === 'CARTAO_BENEFICIO') return 'RCC_SAQUE';
  if (tipo === 'CARTAO_BENEFICIO_COMPRA') return 'RCC_COMPRA';
  return tipo;
};
